<template>
	<div class="add-big-class">
		<!-- 原小类编辑区域 -->
		<el-form ref="form" :model="addCategoryForm" @submit.native.prevent :inline-message='false' :rules="addCategoryRules" label-width="140px" style="position:relative">
			<el-form-item label="店铺级小类：" prop="className">
				<el-input
					v-model="addCategoryForm.className"
					autocomplete="off"
					size='mini'
					style="width:200px;float:left"
					placeholder="请输入店铺级小类"
				></el-input>
			</el-form-item>
			<!-- 三级类别区域（开关开启时显示） -->
			<el-form-item style="margin-top:15px;" v-if="thirdCategoryEnabled" label="三级类别名称：">
				<div class="third-category-section">
					<div class="third-category-header">
						<el-input
							v-model="thirdInputName"
							autocomplete="off"
							size="mini"
							style="width:200px"
							placeholder="请输入三级类别名称"
							maxlength="10"
							@keyup.enter.native="onThirdAddClick"
						></el-input>
						<el-button size="mini" type="primary" plain class="btn-add" @click="onThirdAddClick">+添加</el-button>
					</div>
					<el-table class="third-category-table" size='mini' :data="thirdCategoryList" border height="200">
						<el-table-column align="center"
							prop="name"
							label="三级类别名称"
							min-width="150">
							<template slot-scope="scope">
								<span :class="{ 'is-default': scope.row.isDefault }">{{ scope.row.name }}</span>
								<span v-if="scope.row.isDefault" class="default-tag">默认</span>
							</template>
						</el-table-column>
						<el-table-column label="操作" align="center" min-width="150" class-name="last-colum">
							<template slot-scope="scope">
								<el-button
									v-if="!scope.row.isDefault"
									icon="el-icon-edit"
									size="mini"
									type='text'
									@click="onThirdEditItem(scope.$index)">编辑</el-button>
								<el-button
									v-if="!scope.row.isDefault"
									icon="el-icon-delete"
									size="mini"
									type='text'
									@click="onThirdDeleteItem(scope.$index)">删除</el-button>
							</template>
						</el-table-column>
					</el-table>
				</div>
			</el-form-item>
		</el-form>
		<div slot="footer" class="dialog-footer">
			<el-button class="fx-btn" size="mini" @click="onCancelClick">取 消</el-button>
			<el-button class="fx-btn" type="primary" size="mini" @click="onSaveClick">保 存</el-button>
		</div>
	</div>
</template>

<script>
export default {
	name: 'addSmallClass',
	props: {
		visibleFlag: Boolean,
		data: {
			type: Object,
			default: () => {}
		},
		templateId: {
			type: String,
			default: ''
		},
		thirdCategoryEnabled: {
			type: Boolean,
			default: false
		}
	},
	data () {
		let validateName = (rule, value, callback) => {
			if (value === '') {
				callback(new Error('店铺级小类不能为空'))
			} else if (value.length > 20) {
				callback(new Error('店铺级小类名称最多20个字'))
			} else if (!this.chinessReg.test(value)) {
				callback(new Error('请输入中文或英文'))
			} else {
				callback()
			}
		}
		return {
			showError: false,
			chinessReg: /^[\u0391-\uFFE5A-Za-z]+$/,
			thirdCategoryNameReg: /^[\u0391-\uFFE5A-Za-z]+$/,
			addCategoryForm: {
				className: ''
			},
			addCategoryRules: {
				className: [
					{ required: true, validator: validateName }
				]
			},
			previewSrc: '',
			files: '',
			thirdInputName: '',
			thirdCategoryList: []
		}
	},
	created () {
		this.randerPreview()
		this.thirdInputName = ''
		this.thirdCategoryList = []
		if (this.thirdCategoryEnabled && this.data.id) {
			this.getThirdCategoryList()
		}
	},
	methods: {
		randerPreview () {
			if (this.$fxUtils.isEmptyObjSHW(this.data)) {
				this.addCategoryForm.className = ''
			} else {
				this.addCategoryForm.className = this.data.name || this.data.shopCategoryName || ''
			}
		},
		// 三级类别相关方法
		getThirdCategoryList () {
			let pid = this.data.id
			if (!pid) return
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/getThirdCategory`,
				data: { pid }
			}).then(res => {
				if (res.result) {
					this.thirdCategoryList = (res.data || []).map(item => {
						return {
							...item,
							isDefault: item.name === '默认三级类别'
						}
					})
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		validateThirdName (name) {
			if (!name || name.trim() === '') {
				this.$message.warning('请输入三级类别名称')
				return false
			}
			if (name.length > 10) {
				this.$message.warning('三级类别名称最多10个字')
				return false
			}
			if (!this.thirdCategoryNameReg.test(name)) {
				this.$message.warning('请输入中文或英文')
				return false
			}
			return true
		},
		onThirdAddClick () {
			let name = this.thirdInputName.trim()
			if (!this.validateThirdName(name)) return
			this.thirdCategoryList.push({
				id: '',
				name: name,
				isDefault: false
			})
			this.thirdInputName = ''
		},
		onThirdEditItem (index) {
			this.$prompt('请输入三级类别名称', '编辑', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				inputValue: this.thirdCategoryList[index].name,
				inputMaxLength: 10,
				closeOnClickModal: false
			}).then(({ value }) => {
				if (!this.validateThirdName(value)) return
				this.$set(this.thirdCategoryList, index, {
					...this.thirdCategoryList[index],
					name: value
				})
			}).catch(() => {})
		},
		onThirdDeleteItem (index) {
			this.thirdCategoryList.splice(index, 1)
		},
		saveThirdCategory (pid) {
			let data = {
				pid,
				shopCategoryInfoList: this.thirdCategoryList.map((item, index) => {
					return {
						name: item.name,
						type: 2,
						seqnum: index + 1
					}
				})
			}
			return this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/batchUpdateShopCategory`,
				data
			})
		},
		// 原小类相关方法
		refreshData () {
			this.$emit('refreshData')
		},
		onCancelClick () {
			this.$emit('update:visibleFlag', false)
		},
		onSaveClick () {
			this.$refs.form.validate(valid => {
				if (!valid) return
				const isAdd = this.$fxUtils.isEmptyObjSHW(this.data)
				const saveSmallClass = isAdd ? this.requestAddHandle() : this.requestUpdateHandle()
				saveSmallClass.then(smallClassId => {
					if (!this.thirdCategoryEnabled) {
						this.onSaveSuccess(isAdd ? '新增店铺级小类成功!' : '更新店铺级小类成功!')
						return
					}
					return this.saveThirdCategory(smallClassId).then(res => {
						if (res.result) {
							this.onSaveSuccess(isAdd ? '新增店铺级小类成功!' : '更新店铺级小类成功!')
						} else {
							this.$message.error(res.msg)
						}
					})
				}).catch(res => {
					if (res && res.msg) {
						this.$message.error(res.msg)
					}
				})
			})
		},
		onSaveSuccess (message) {
			this.$message({
				message,
				type: 'success'
			})
			this.$emit('update:visibleFlag', false)
			this.refreshData()
		},
		requestAddHandle () {
			let pId = this.$parent.$parent.smallClassData.bc_id
			let param = {
				name: this.addCategoryForm.className,
				pid: pId,
				type: 1
			}
			return this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/saveShopCategory`,
				data: param
			}).then(res => {
				if (res.result && res.data && res.data.id) {
					return res.data.id
				}
				return Promise.reject(res)
			})
		},
		requestUpdateHandle () {
			let pId = this.$parent.$parent.smallClassData.bc_id
			let param = {
				id: this.data.id,
				name: this.addCategoryForm.className,
				pid: pId,
				type: 1
			}
			return this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/updateShopCategory`,
				data: param
			}).then(res => {
				if (res.result) {
					return this.data.id
				}
				return Promise.reject(res)
			})
		}
	}
}
</script>
<style scoped lang="stylus">
.add-big-class {
	.third-category-section {
		.third-category-header {
			display: flex
			align-items: center
			margin-bottom: 10px
			/deep/ .el-input__inner {
				font-size: 14px
				color: #606266
			}
			.btn-add {
				margin-left: 10px
				font-size: 14px
			}
		}
		.third-category-table {
			width: 100%
			/deep/ .el-table__header-wrapper {
				th {
					padding: 0
					height: 28px
					.cell {
						font-size: 14px
						font-weight: normal
						color: #606266
						line-height: 28px
						padding: 0 10px
					}
				}
			}
			/deep/ .el-table__body-wrapper td {
				padding: 4px 0
				.cell {
					font-size: 14px
					font-weight: normal
					color: #606266
					line-height: 20px
				}
			}
			/deep/ .el-table__empty-text {
				font-size: 14px
				color: #606266
			}
			.is-default {
				color: #999
			}
			.default-tag {
				font-size: 12px
				color: #999
				background: #f5f5f5
				padding: 2px 6px
				border-radius: 3px
				margin-left: 8px
			}
			.last-colum {
				border-right: none !important
			}
		}
	}
	.upload-label {
		text-align:center
	}
	.img-upload,.img-preview {
		width: 178px;
		height: 178px;
		line-height: 178px;
		display: inline-block
	}
	.img-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
		text-align: center;
		font-size: 28px;
		color: #8c939d;
		&:hover {
			border-color: var(--fx-primary-color);
		}
	}
	.img-preview {
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}
	.format-text {
		height:50px
		line-height:50px
	}
	.dialog-footer {
		margin-top: 30px
	}
}
</style>
